// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/chip.js
import BaseComponent from "./base_component"

export default class Chip extends BaseComponent {
  static componentName = "chip"
  static defaults = { disabled: false, filter: false, removable: false, selectable: false, selected: false }

  constructor(element, config = {}) {
    super(element, config)
    this.value = element.dataset.coreuiValue || element.textContent.trim()
    this.disabled = this.config.disabled || element.classList.contains("disabled")
    this.selectable = this.config.selectable || this.config.filter
    this.selected = this.config.selected || element.classList.contains("active")
    if (this.selectable) {
      element.classList.add("chip-clickable")
      element.setAttribute("role", "button")
    }
    if (this.selectable || this.config.removable) element.tabIndex = this.disabled ? -1 : 0
    element.setAttribute("aria-disabled", this.disabled)
    if (this.config.filter) {
      const check = document.createElement("span")
      check.className = "chip-check"
      check.setAttribute("aria-hidden", "true")
      check.textContent = "✓"
      this.check = check
      element.prepend(check)
    }
    if (this.config.removable) {
      const remove = document.createElement("button")
      remove.type = "button"
      remove.className = "chip-remove"
      remove.setAttribute("aria-label", this.config.ariaRemoveLabel || `Remove ${this.value}`)
      remove.textContent = "×"
      remove.disabled = this.disabled
      element.append(remove)
    }
    this.update()
    this.listen(element, "click", (event) => {
      if (event.target.closest(".chip-remove")) this.remove()
      else this.toggle()
    })
    this.listen(element, "keydown", (event) => {
      if (event.target !== element) return
      if (["Enter", " "].includes(event.key)) {
        event.preventDefault()
        this.toggle()
      }
      if (["Backspace", "Delete"].includes(event.key) && this.config.removable) {
        event.preventDefault()
        this.remove()
      }
    })
  }

  update() {
    this.element.classList.toggle("active", Boolean(this.selected))
    this.check?.classList.toggle("d-none", !this.selected)
    if (this.selectable) this.element.setAttribute("aria-pressed", Boolean(this.selected))
  }

  toggle() {
    this.setSelected(!this.selected)
  }

  setSelected(selected) {
    if (this.disabled || !this.selectable || this.selected === selected) return
    if (this.emit(selected ? "select" : "deselect", {}, { cancelable: true }).defaultPrevented) return
    this.selected = selected
    this.update()
    this.emit(selected ? "selected" : "deselected")
  }

  remove() {
    if (this.disabled || !this.config.removable || this.emit("remove", {}, { cancelable: true }).defaultPrevented)
      return
    // Notify the owning collection while the chip can still bubble to it.
    this.emit("removed", { value: this.value })
    this.dispose()
    this.element.remove()
  }

  dispose() {
    if (this.signal.aborted) return
    this.element.innerHTML = this.originalHTML
    this.element.className = this.originalClassName
    super.dispose()
  }
  snapshotState() {
    return { config: { selected: this.selected } }
  }
}
